import { ICommand, IDefineCommand, IQuery } from 'core-ts-types';
import { INVALID_ID } from '../../../../global/constants/ap_id_constants';
import { APCourse } from '../../../builders/ap_course_builder';
import { IAPCoursesDatasource } from '../../../datasources/ap_courses_datasource';
import { APCourseInfoModel } from '../models/course_info_model';

angular
  .module('capability-ng-academic-planner')
  .factory(
    'unsaveFavoriteCourseCommand',
    function unsaveFavoriteCourseCommandDefinition(
      log: any,
      $http: ng.IHttpService,
      ngAPCoursesDatasource: IAPCoursesDatasource,
      ngAPCourseInfoModel: APCourseInfoModel,
      defineCommandORM: IDefineCommand
    ): ICommand {
      return defineCommandORM(
        'unsaveFavoriteCourseCommand',
        function unsaveFavoriteCourseCommand(deferred: ng.IDeferred<any>, course: APCourse): void {
          $http
            .delete(`favorite/favoriteitem/${course.favorite_id}`)
            .then(() => {
              course.is_favorite = false;
              course.favorite_id = INVALID_ID;
              ngAPCoursesDatasource.put(course);
              ngAPCourseInfoModel.write({
                course: {
                  [course.id]: course
                }
              });
              deferred.resolve(course);
            })
            .catch((e) => {
              log.issue('failed to remove course from favorites');
              deferred.reject(e);
            });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/components/course_detail/commands/unsave_favorite_course_command.ts